export default function openSearch() {
  let iconBlock = $('.openSearch__icon');
  let iconOpen = iconBlock.data('iconopen');
  let iconClose = iconBlock.data('iconclose');
  $('#openSearch').on('change', function () {
    if ($('#openSearch:checked').length > 0) {
      $('body').css('overflow', 'hidden');
      iconBlock.html(iconClose);
    } else {
      $('body').removeAttr('style');
      iconBlock.html(iconOpen);
    }
  })
}